var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Brime Developer SDKs"}},[_c('b-card-text',[_vm._v("Stay tuned.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }